// Utils
import { propIn } from '../../../common/utils/immutableHelper';

export const isInstalledPwaSelector = (state) => propIn(['app', 'pwaApp', 'isPwa'], state) || false;
